export default "__VITE_ASSET__BEZpRmdP__"